import React, { useCallback } from "react";
import { useLanding } from "../providers/landing-provider";
import QuotationPopup from "../../quotation-popup/quotation-popup";
import Header from "../../../components/header/header";
import iconAspa from "../../../assets/icons/ic-aspa.svg";
import { Column } from "../../../components/layout/flex-layout";
import { Flex } from "../../../components/layout/flex";
import { useScrollLock } from "../../../hooks/use-scroll-lock";
import { useWindowResize } from "../../../hooks/use-windows-resize";
import classnames from "classnames";
import { useChannel } from "../../../libs/channels/hooks/use-channel";

const LandingQuotationPopupContent = () => {
    const { isOpenedquotationPopup, setOpenedQuotationPopup } = useLanding();
    const close = useCallback(() => setOpenedQuotationPopup(false), []);
    const { isMobile } = useWindowResize();
    const { isBcpTheme } = useChannel();
    useScrollLock();
    return (
        <Column
            data-testid="LandingQuotationPopup"
            className={classnames("landing-quotation-popup", {
                desktop: !isMobile,
                bcp: isBcpTheme,
            })}
        >
            <div className="landing-quotation-popup__header">
                <Header visible={true} />
                <button
                    className="landing-quotation-popup__header__close"
                    onClick={close}
                >
                    <img src={iconAspa} alt="cerrar popup" />
                </button>
            </div>
            <Flex className="landing-quotation-popup__content">
                {isOpenedquotationPopup && <QuotationPopup />}
            </Flex>
        </Column>
    );
};

export const LandingQuotationPopup = () => {
    const { isOpenedquotationPopup } = useLanding();
    return isOpenedquotationPopup && <LandingQuotationPopupContent />;
};
